import { useState, useEffect } from 'react';
import { MiturLogoImage, AuthBackgroundImage, FormSchema } from './RequestPasswordConstants';
import {
    LogoImage,
    Image,
    RowContainer,
    LeftPanelContainer,
    Title,
    FlexStartContainer,
    LinkText,
    BodyText,
    FooterContainer,
    TextFieldContainer,
    TextError
} from './styles/RequestPasswordStyles';
import { StyledButton, Row, SmallHeightDivider, MediumHeightDivider } from '../../../theme/Styles';
import COLORS from '../../../theme/Colors';
import { useFormik } from 'formik';
import { useHistory } from 'react-router';
import TextField from '../../../components/TextField/TextField';
import { useDispatch, useSelector } from "react-redux";
import { removeGuionFromString } from '../../../utilities/functions/StringUtil';
import { useSnackbar } from 'notistack';
import {restorePassword} from '../../../api/RequestPassword'
import { HideGlobalLoading, ShowGlobalLoading } from '../../../redux/actions/UiActions';
function RequestPassword() {

    const dispatch = useDispatch();
    const history = useHistory();
    const { authenticated } = useSelector((state) => state.authReducer);
    const { enqueueSnackbar } = useSnackbar();

    const [errorMessage, setErrorMessage] = useState('');

    const formik = useFormik({
        initialValues: {
            id: '',
            email: '',
            emailConfirmation: ''
        },
        validationSchema: FormSchema,
        onSubmit: (values) => {
            //alert(JSON.stringify(values, null, 2));
            onRequest(values);
        },
    });

    const onRequest = async (formData) => {
        try {
            dispatch(ShowGlobalLoading("Cargando"));
            const response = await restorePassword({
                citizen_id: removeGuionFromString(formData.id),
                email: formData.email
            });
            if (response.success) {//IF passwordRequest SUCCESS
                enqueueSnackbar("Se ha enviado un mensaje a su correo electrónico", { variant: 'success' })
                history.push('/login')
            }else{
                setErrorMessage(response?.msg)
               // enqueueSnackbar("Ha ocurrido un error favor intentar mas tarde.", { variant: 'error' })
            }
            dispatch(HideGlobalLoading());
        } catch (error) {
            enqueueSnackbar("Ha ocurrido un error favor intentar mas tarde.", { variant: 'error' })
            dispatch(HideGlobalLoading());
        }
    }

    useEffect(() => {
        if (authenticated) {
            history.push('/app/mi-escritorio')
            return;
        }
    }, []);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 27px)', width: '100%', overflowY: 'auto' }}>
            <RowContainer style={{ flex: 1, overflowY: 'auto' }}>
                <LeftPanelContainer>
                    <LogoImage src={MiturLogoImage} />
                    <SmallHeightDivider />
                    <Title style={{ textAlign: 'center' }}>Restablecer contraseña</Title>
                    <SmallHeightDivider />
                    <SmallHeightDivider />
                    <FlexStartContainer>
                        <TextFieldContainer>
                            <TextField 
                                title="Documento"
                                placeholder="Cédula o Pasaporte" 
                                type="text" 
                                id="id"
                                value={formik.values.id}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.id && Boolean(formik.errors.id)}
                                helperText={formik.touched.id && formik.errors.id}
                            />

                        </TextFieldContainer>

                        <TextFieldContainer>
                            <TextField 
                                title="Correo Electrónico"
                                placeholder="Ingrese su correo" 
                                type="email" 
                                id="email"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email && formik.errors.email}
                            />

                        </TextFieldContainer>

                        <TextFieldContainer>
                            <TextField 
                                title="Confirmar correo electrónico"
                                placeholder="Repita su correo" 
                                type="email" 
                                id="emailConfirmation"
                                value={formik.values.emailConfirmation}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.emailConfirmation && Boolean(formik.errors.emailConfirmation)}
                                helperText={formik.touched.emailConfirmation && formik.errors.emailConfirmation}
                            />
                        </TextFieldContainer>
                        <TextError>{errorMessage}</TextError>
                        <SmallHeightDivider />
                        <StyledButton 
                            onClick={() => formik.handleSubmit()}
                            style={{ width: 'auto', minWidth: '250px', alignSelf: 'center', padding: '12px 40px' }}
                        >
                            Restablecer contraseña
                        </StyledButton>
                        <SmallHeightDivider />

                        <LinkText
                            to='/login'
                            style={{
                                color: COLORS.primary,
                                textDecoration: 'none',
                                fontWeight: 'bold'
                            }}>Regresar al login</LinkText>
                    </FlexStartContainer>
                </LeftPanelContainer>
                <Image style={{
                    backgroundImage: `url(${AuthBackgroundImage})`
                }} />
            </RowContainer>
            <mitur-footer variant="minimal"></mitur-footer>
        </div>
    );
}

export default RequestPassword;
